import { useState } from 'react';
import { RequestSettings } from './types';
import UseAuthConfig from './useAuthConfig';

const useRequestSettings = (): [RequestSettings, (settings: Partial<RequestSettings>) => void] => {
  const { protectedResources }: any = UseAuthConfig();
  const [reqRequests, setReqRequest] = useState<RequestSettings>({
    PageNumber: 1,
    SearchText: '',
    Name: '',
    PerformanceType: '',
    SortOrder: 1,
    PageSize: 5,
    OrderBy: 'JobTitle',
    ParameterOne: 'Active,Inactive,Pending',
    ParameterTwo: 'Customer',
    ParameterThree: '',
    url: protectedResources.apiTodoList.endpoint,
    accessToken: localStorage.getItem('AccessToken') || ""
  });

  const updateSettings = (settings: Partial<RequestSettings>) => {
    setReqRequest(prevSettings => ({ ...prevSettings, ...settings }));
  };

  return [reqRequests, updateSettings];
};

export default useRequestSettings;
